import { useQuickPanel } from "./QuickPanelProvider";
import QuickTasksModal from "./QuickTasksModal";
import QuickNotesModal from "./QuickNotesModal";

/** Um modal por vez: Tarefas e Notas são experiências independentes. */
export default function QuickPanelModals() {
  const { aberto, fechar } = useQuickPanel();
  return (
    <>
      <QuickTasksModal open={aberto === "tasks"} onClose={fechar} />
      <QuickNotesModal open={aberto === "notes"} onClose={fechar} />
    </>
  );
}
